import { Alert as DesignSystemAlert } from '@openx/design-system/components/Alert/Alert.tsx';

type AlertProps = {
  message?: string;
};

export const Alert = ({ message }: AlertProps) => {
  if (!message) return null;

  return <DesignSystemAlert severity="info">{message}</DesignSystemAlert>;
};
